export default [
	'INVOICE',
	'CREDIT_NOTE',
	'DEBIT_NOTE',
	'PAYMENT'
];
